import SettingTimesheetMasterData from "../components/SettingTimesheetMasterData";
import useTimeSheetMasterData from "../hooks/useTimeSheetMasterData";

const SettingTimesheetMasterPage = () => {
    const props = useTimeSheetMasterData()
    return (
        <SettingTimesheetMasterData {...props} />
    )
}

export default SettingTimesheetMasterPage;